import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_PASSWORD_POLICY: createActionType(FULL_NAMESPACE, "GET_PASSWORD_POLICY"),
    GET_PASSWORD_POLICY_COMPLETED: createActionType(FULL_NAMESPACE, "GET_PASSWORD_POLICY_COMPLETED"),
    SAVE_PASSWORD_POLICY: createActionType(FULL_NAMESPACE, "SAVE_PASSWORD_POLICY"),
    SAVE_PASSWORD_POLICY_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_PASSWORD_POLICY_COMPLETED")
};
